<template>
  <v-container fluid class="worker-role-form mt-3 mx-1 centered-tabs" v-show="showComponent">
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <h2 class="primary--text font-weight-bold pt-5 pl-2">
            {{ edit ? $t('book/admin:worker-role.edit.titles.edit') : $t('book/admin:worker-role.edit.titles.add') }}
          </h2>

          <v-card
              elevation="0"
              flat
              tile
          >
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12" md="6">
                  <h4 class="primary--text font-weight-medium">{{ $t('common:general') }}</h4>
                  <!-- Role name -->
                  <v-text-field
                      outlined
                      v-model="data.name"
                      clearable
                      :label="$t('common:name')"
                      :rules="[ruleRequired($t('utils:rules.required'))]"
                      tabindex="1"
                  />

                  <!-- Certificate -->
                  <v-checkbox
                      color="secondary"
                      v-model="data.requireCertificate"
                      :label="$t('book/admin:worker-role.common.certificate')"
                      tabindex="2"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card
              elevation="0"
              flat
              tile
          >
            <v-card-text class="pa-5 pb-4">
              <BaseButton
                  color="primary"
                  :btn-text="$t('buttons:save')"
                  @clickedButton="saveRole()"
              />

              <TwoButtonDialog
                  v-if="edit"
                  ref="deleteButton"
                  :btn-text="$t('buttons:delete')"
                  color="error"
                  :dialog-title="$t('dialog:delete-btn-title', {name : $t('book/admin:worker-role.edit.dialog-part-1')})"
                  :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('book/admin:worker-role.edit.dialog-part-2')})"
                  :button1-text="$t('buttons:cancel')"
                  :button2-text="$t('buttons:delete')"
                  @clickedButton1="$refs.deleteButton.showDialog = false"
                  @clickedButton2="deleteRole()"
              />

              <DirtyConfirmButtonDialog
                  ref="dirtyDialog"
                  :btn-text="$t('buttons:back')"
                  color="grey"
                  :dialog-title="$t('dialog:dirty-save-btn-title')"
                  :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                  :button1-text="$t('dialog:dirty-save-btn-1-text')"
                  :button2-text="$t('dialog:dirty-save-btn-2-text')"
                  @clickedButton="$router.go(-1)"
                  :dataToWatch="data"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import WorkerRole from "@/modules/core/data/worker-role";
import WorkerRoleService from "@/modules/core/services/worker-role-service";
import TwoButtonDialog from "@/modules/core/components/TwoButtonDialog/TwoButtonDialog";
import Utils from "../../../core/services/utils";
import {ruleRequired} from "../../../core/services/rules";
import DataUtils from "@/modules/core/services/data-utils";
import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";
import BaseButton from "@/modules/core/components/Base/BaseButton";

export default {
  name: "WorkerRoleForm",
  components: {
    TwoButtonDialog,
    DirtyConfirmButtonDialog,
    BaseButton
  },
  data() {
    return {
      data: new WorkerRole(),
      edit: false,
      isFetchingRole: true,
      dirty: false
    }
  },
  methods: {
    saveRole() {
      if (!this.$refs.form.validate()) {
        // TODO scroll to specific form field which doesnt require the rules
        window.scrollTo(0, 0);
        return;
      }

      if (!this.edit) {
        WorkerRoleService.postToAPI(this.data,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('common:role')}));
            this.$router.go(-1)
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('common:role')}))
          }
        )
      } else {
        WorkerRoleService.putToAPI(this.data,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('common:role')}));
            this.$router.go(-1)
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('common:role')}))
          }
        )
      }
    },
    deleteRole() {
      this.$refs.deleteButton.setButtonSettings(true, true, false, true);

      WorkerRoleService.deleteFromAPI(this.data,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('common:role')}));
          this.$router.go(-1)
        },
        () => {
          this.$refs.deleteButton.setButtonSettings(false, false, false, false);
          this.$refs.deleteButton.showDialog = false;
          Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('common:role')}))
        }
      )
    },
    ruleRequired
  },
  computed: {
    currentLang() {
      return this.$store.state.translation.language;
    },
    showComponent() {
      if(this.edit) {
        if(this.isFetchingRole) {
          return false
        } else {
          return true;
        }
      } else {
        return true
      }
    }
  },
  watch: {
    currentLang() {
      this.$refs.form.resetValidation()
    }
  },
  created() {
    if (this.$route.params.id) {
      this.edit = true

      WorkerRoleService.readFromAPI(this.$route.params.id,
        (resp) => {
          var response = DataUtils.parseDataToSingleObject(resp.data, WorkerRole);
          if (response == null) {
            this.$router.go(-1);
          } else {
            this.data = response;
            this.isFetchingRole = false;
            this.$refs.dirtyDialog.startWatch();
          }
        },
        (error) => {
          this.$router.push('/404')
          this.$logger.error("Error at getting Worker Role: " + error)
        }
      )
    }
  },
  mounted() {
    this.$refs.dirtyDialog.startWatch();
  }
}
</script>
